/* One controller for the current Liquid banner. No dependencies or cloned DOM. */
(() => {
  if (window.ccClientBannerInitialised) return;
  window.ccClientBannerInitialised = true;
  const controllers = new Map();
  function initialise(root) {
    root.querySelectorAll('.cc-clients-v2').forEach(banner => {
      if (controllers.has(banner)) return;
      if (!banner.querySelector('.cc-v2-moving') || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => banner.classList.toggle('cc-band-visible', entry.isIntersecting));
      });
      banner.classList.add('cc-band-enhanced');
      observer.observe(banner);
      controllers.set(banner, () => {
        observer.disconnect();
        banner.classList.remove('cc-band-enhanced', 'cc-band-visible');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), {once:true});
  } else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((cleanup, banner) => {
      if (event.target.contains(banner)) { cleanup(); controllers.delete(banner); }
    });
  });
})();
